/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {IComponent} from "../../../containers/components/Global/Dialog/GlobalDialog";

interface IState {
  component: IComponent | null
  isOpen: boolean
  isEditOpen: boolean
}

const initialState: IState = {
  component: null,
  isOpen: false,
  isEditOpen: false,
} as IState

const slice = createSlice({
  name: 'globalDialogSlice',
  initialState,
  reducers: {
    setIsGlobalDialogOpen: (state, action: PayloadAction<boolean>) => void (state.isOpen = action.payload),
    setGlobalDialogComponent: (state, action: PayloadAction<IComponent>) => void (state.component = action.payload),
    setIsConfigurableDialogOpen: (state, action: PayloadAction<boolean>) => void (state.isEditOpen = action.payload),
  }
})

const selectGlobalDialogState = (state: RootState) => state.globalDialog

const {actions, reducer} = slice
export {
  selectGlobalDialogState
}
export const {
  setIsGlobalDialogOpen,
  setGlobalDialogComponent,
  setIsConfigurableDialogOpen
} = actions

export default reducer
